import { Color } from 'state/color'
import 'state/color/events/initializeAliases'

MK.events.on('color:initialize', (event = {}) => {
  const index = event.target
  console.log('DEBUG (color.initialize): Initializing product colors.')

  for (let [family, colorVariants] of Object.entries(index.colors)) {
    for (let variant of colorVariants) {
      let [name, id] = `${variant}`.split('|')
      if (name && id) {
        new Color({
          family,
          name,
          id
        })
      }
    }
  }

  console.log(`DEBUG (color:initialize): Total color IDs: ${Object.keys(Color.by.id).length}`)
})